<template>
  <section class="request-detail">
    <div class="text-right">
      <v-button
        type="primary"
        :disabled="disabledEdit"
        plain
        @click="() => $emit('edit')">Edit Request</v-button>
    </div>
    <div
      v-if="form.is_share_guest_order"
      class="pt-20">
      <div class="table">
        <div class="tr">
          <span>Contact Person</span>
          <span>{{form.share_referral_nm ? form.share_referral_nm : 'Share Initiator'}}</span>
        </div>
      </div>
    </div>
    <template v-if="type==2">
      <div class="table pt-20">
        <div class="th font-14" >Referrer Detail</div>
        <div class="tr tr--none_border_top">
          <span>Referrer</span>
          <span
            v-if="referrer"
            class="flex-align-center">
            <span
              class="referrer blue"
            >
              <router-link
                class="blue text-decoration-none"
                :to="{path:'/accounts/detail',query:{customer_id:referrer.id}}">{{referrer.isrd_nm}}
              </router-link>
            </span>

            <div class="tags">
              <span
                v-if="referrer.is_tier_base"
                class="span-status blue">
                Professional
              </span>
            </div>
          </span>
        </div>
        <div
          v-if="form.merchant_platform==1&&form.discount_str"
          class="tr tr--none_border_top">
          <span>Referrer Discount</span>
          <span>{{form.discount_str}}</span>
        </div>
      </div>
    </template>
    <template v-if="type === 2">
      <h2 v-if="productId!=13">Quick Quote Detail</h2>
      <quick-quote-info
        v-if="productId!=13&&productId!=80"
        :productId="productId"
        :quoteForm="form"></quick-quote-info>
      <sme-qucik-info
        v-if="productId==80"
        :form-data="referData"
        :sme-class-id="referData.class_id"></sme-qucik-info>
      <h2>Policy Detail</h2>
      <housemaid-quote-info
        v-if="productId == 12"
        :title="false"
        show-company
        :formData="form" />
      <decoration-quote-info
        v-else-if="productId == 15"
        :title="false"
        show-company
        :formData="form" />
      <travel-quote-info
        v-else-if="productId == 14"
        :title="false"
        show-company
        :formData="form" />
      <homefire-quote-info
        v-else-if="productId == 17"
        :title="false"
        show-company
        :formData="form" />
      <personal-quote-info
        v-else-if="productId == 18"
        :title="false"
        show-company
        :formData="form" />
      <student-quote-info
        v-else-if="productId == 16"
        :title="false"
        show-company
        :formData="form" >
      </student-quote-info>
      <working-quote-info
        v-else-if="productId == 13"
        :title="false"
        show-company
        :formData="form">
      </working-quote-info >
      <fire-quote-info
        v-else-if="productId == 20"
        :title="false"
        :formData="form" />
      <drone-quote-info
        v-else-if="productId == 21"
        :title="false"
        :formData="form" />
      <pet-quote-info
        v-else-if="productId == 22"
        :title="false"
        :formData="form" />
      <template v-else-if="productId==80">
        <sme-kyc-info
          :form-data="referData"
          :class-id="referData.class_id"></sme-kyc-info>
      </template>
      <template v-else>
        <div class="table strip">
          <div class="tr">
            <span>Expected Effective Date</span>
            <span v-copy="`${form.period_start} - ${form.period_end}`">
              {{ form.period_start }} - {{ form.period_end }}
              <span
                v-if="form.is_eff_dt_delay"
                class="asap">(ASAP)</span>
            </span>
          </div>
          <template v-if="isHzmb">
            <div class="tr">
              <span>汽車貸款？</span>
              <span v-copy="form.product_language">{{ form.product_language }}</span>
            </div>
            <div class="tr">
              <span>貸款機構名稱</span>
              <span v-copy="form.product_language">{{ form.product_language }}</span>
            </div>
          </template>
          <template v-if="!isHzmb">
            <div class="tr">
              <span>Insurance Type</span>
              <span v-copy="form.product_language">{{ form.product_language }}</span>
            </div>
            <div
              v-if="form.trm_of_cvr != 1"
              class="tr">
              <span>Sum Insured</span>
              <span v-copy="form.isrd_vl">{{ form.isrd_vl }}</span>
            </div>
            <div
              v-if="form.trm_of_cvr != 1"
              class="tr">
              <span>Hire Purchase Owner</span>
              <span v-copy="getOptionName('yesNoOptions', form.hp_ind)">{{getOptionName('yesNoOptions', form.hp_ind)  }}</span>
            </div>
            <div
              v-if="form.trm_of_cvr != 1 && form.hp_ind == 1"
              class="tr">
              <span>Name of Hire Purchase Owner (If Yes for Hire purchase)</span>
              <span
                v-if="!isMortgagorOther"
                v-copy="getLocalAllOptionName('mortgagor', form.mortgagor)">{{ getLocalAllOptionName('mortgagor', form.mortgagor)}}</span>
              <span
                v-else
                v-copy="form.mortgagor_other">{{  form.mortgagor_other}}</span>
            </div>
            <div class="tr">
              <span>More Benefits</span>
              <span
                v-if="benefits.length > 0"
                class="child-span-block">
                <span
                  v-for="(item, index) in benefits"
                  :key="index"
                  v-copy="item.name"
                  class="red">
                  {{ item.name }}
                </span>
              </span>
              <span v-else>None</span>
            </div>
            <div
              v-if="form.class_id==11&&extraBenefitSelect.length>0"
              class="tr">
              <span>Extra Benefits</span>
              <span>
                <span
                  v-for="(item,index) in extraBenefitSelect"
                  :key="'extra'+index"
                  v-copy="item.name">{{item.name}}<br></span>
              </span>
            </div>
            <div
              class="tr">
              <span>Insurer</span>
              <span>
                <span
                  v-copy="form.company_language">{{form.company_language}}</span>
              </span>
            </div>
          </template>
        </div>
        <!--        <h2>Insured Vehicle</h2>-->
        <template   v-if="!isMotorTrade">
          <h2 v-if="form.class_id == 14">Insured Motorcycle Details</h2>
          <h2 v-if="form.class_id == 11||isHzmb">Insured Private Details</h2>
          <h2 v-if="form.class_id == 12">Insured Commercial Vehicle Details</h2>
          <insured-vehicle-info
            :form="form" />
        </template>
        <h2>Policyholder Details</h2>
        <policy-holder-info
          :form="form" />
        <template v-if="isMotorTrade&&!isTPlate||!isMotorTrade">
          <h2>Named Driver Information</h2>
          <drivers-info
            :form="form" />
        </template>
      </template>
    </template>
    <template v-else-if="type === 5">
      <h2>Request Detail</h2>
      <div class="table strip">
        <div class="tr">
          <span>Type</span>
          <span>{{ insuranceType }}</span>
        </div>
      </div>
      <div class="table">
        <div class="tr">
          <span>Name</span>
          <span>{{ form.name }}</span>
        </div>
        <div class="tr">
          <span>Phone No.</span>
          <span>{{ form.phone }}</span>
        </div>
        <div class="tr">
          <span>Email</span>
          <span>{{ form.email }}</span>
        </div>
        <div class="tr">
          <span>Referral Code</span>
          <span>{{ form.promo_code }}</span>
        </div>
        <div class="tr">
          <span>Coupon Code</span>
          <span>{{ form.coupon_code }}</span>
        </div>
        <div class="tr">
          <span>Renewal Notice</span>
          <span
            v-if="form.renewal_notice&&form.renewal_notice.url"
            class="blue pointer"
            @click="openFile(form.renewal_notice.url?form.renewal_notice.url:null)">{{ form.renewal_notice? form.renewal_notice.client_name: '' }}</span>
        </div>

        <industry-info
          v-if="isIndustry"
          :form="form" />
        <!-- Business Package -->
        <section v-if="form.insurance_type === 1001">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Effective Date </span>
            <span>{{ form.eff_dt }}</span>
          </div>
          <div class="tr">
            <span>Business Nature </span>
            <span>
              {{ getGlobalOptionName('industry', form.business) }}
            </span>
          </div>
          <div class="tr">
            <span>Sum Insured - Building </span>
            <span>{{ form.sum_building | formatMoney }} HK$</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Contents </span>
            <span>{{ form.sum_content | formatMoney }} HK$</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Stock</span>
            <span>{{ form.sum_stock | formatMoney }} HK$</span>
          </div>
          <div class="tr">
            <span>No. of Employee(s)</span>
            <span>{{ form.no_of_employee }} Person</span>
          </div>
          <div class="tr">
            <span>Have you made or reported claim in the last 3 years?</span>
            <!-- <v-input v-model="formData.claim_ind" /> -->
            <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Do you have any existing policy schedule(s)?</span>
            <span>{{ getOptionName('yesNo2Options', form.pcy_sch_ind) | formatYesNo }}</span>
          </div>
          <span class="address-label">Insured Premises Address</span>
          <div class="tr">
            <span>Room</span>
            <span>{{ form.addr_room }}</span>
          </div>
          <div class="tr">
            <span>Floor</span>
            <span>{{ form.addr_floor }}</span>
          </div>
          <div class="tr">
            <span>Block</span>
            <span>{{ form.addr_block }}</span>
          </div>
          <div class="tr">
            <span>Building / Estate</span>
            <span>{{ form.addr_building }}</span>
          </div>
          <div class="tr">
            <span>Street</span>
            <span>{{ form.addr_street }}</span>
          </div>
          <div class="tr">
            <span>District</span>
            <span>{{ getAreaName('district', form.addr_district) }}</span>
          </div>
          <div class="tr">
            <span>Area</span>
            <span>{{ getAreaName('area', form.addr_area) }}</span>
          </div>
          <div class="tr">
            <span>Country / Region</span>
            <span>{{ getAreaName('region', form.addr_region) }}</span>
          </div>
        </section>
        <!-- Employee Compensation (E.C.) -->
        <section v-if="form.insurance_type === 1101">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Effective Date </span>
            <span>{{ form.eff_dt }}</span>
          </div>
          <div class="tr">
            <span>Business Nature </span>
            <span>
              {{ getGlobalOptionName('industry', form.business) }}
            </span>
          </div>
          <div class="tr">
            <span>No. of Employee(s)</span>
            <span>{{ form.no_of_employee }} Person</span>
          </div>
          <div class="tr">
            <span>Work oversea?</span>
            <span>{{ getOptionName('yesNo2Options', form.oversea_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Have you made or reported a claim in the last 3 years?</span>
            <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Do you have any existing policy schedule(s)?</span>
            <span>{{ getOptionName('yesNo2Options', form.pcy_sch_ind) | formatYesNo }}</span>
          </div>
          <span class="address-label">Insured Premises Address</span>
          <div class="tr">
            <span>Room</span>
            <span>{{ form.addr_room }}</span>
          </div>
          <div class="tr">
            <span>Floor</span>
            <span>{{ form.addr_floor }}</span>
          </div>
          <div class="tr">
            <span>Block</span>
            <span>{{ form.addr_block }}</span>
          </div>
          <div class="tr">
            <span>Building / Estate</span>
            <span>{{ form.addr_building }}</span>
          </div>
          <div class="tr">
            <span>Street</span>
            <span>{{ form.addr_street }}</span>
          </div>
          <div class="tr">
            <span>District</span>
            <span>{{ getAreaName('district', form.addr_district) }}</span>
          </div>
          <div class="tr">
            <span>Area</span>
            <span>{{ getAreaName('area', form.addr_area) }}</span>
          </div>
          <div class="tr">
            <span>Country / Region</span>
            <span>{{ getAreaName('region', form.addr_region) }}</span>
          </div>
        </section>
        <!-- Contractors’ All Risks (C.A.R.) -->
        <section v-if="form.insurance_type === 1601">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Contract Period</span>
            <span>{{ getGlobalOptionName('contract_period', form.contract_period) }}</span>
          </div>
          <div class="tr">
            <span>Total Contract Value</span>
            <span>HK$ {{ form.total_contract_vl | formatMoney }}</span>
          </div>
          <div class="tr">
            <span>Material Damage</span>
            <span>{{ getOptionName('yesNo2Options', form.material_damage_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Third Party Liability</span>
            <span>{{ getGlobalOptionName('third_party_liability', form.third_party_liability) }}</span>
            <!-- <span>{{ form.third_party_liability | formatMoney }} HKD</span> -->
          </div>
          <div class="tr">
            <span>Scaffolding Work</span>
            <span>{{ getOptionName('yesNo2Options', form.scaffold_ind) | formatYesNo }}</span>
          </div>
          <!--          <div class="tr">-->
          <!--            <span>Contract Value</span>-->
          <!--            <span>{{ form.contract_vl | formatMoney }} HKD</span>-->
          <!--          </div>-->
          <div class="tr">
            <span>Work at Height</span>
            <span>{{ getGlobalOptionName('work_at_height', form.work_at_height) }}</span>
            <!-- <span>{{ form.work_at_height == 99? form.work_at_height_other: getGlobalOptionName('work_at_height', form.work_at_height) }}</span> -->
          </div>
          <div class="tr">
            <span>Outdoor Work</span>
            <span>{{ getOptionName('yesNo2Options', form.outdoor_ind) | formatYesNo }}</span>
          </div>
          <div
            v-if="form.outdoor_ind == 1"
            class="tr">
            <span>Contract Sum of Out Door Work</span>
            <span>HK$ {{ form.outdoor_vl | formatMoney }}</span>
          </div>
          <div class="tr">
            <span>Employees' Compensation</span>
            <span>{{ getOptionName('yesNo2Options', form.compensation_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Please provide Scope of Work & Contract Breakdown</span>
            <span
              class="blue pointer "
              @click="openFile(form.photos.url? form.photos.url: null)"
            >
              {{ form.photos.id? form.photos.client_name: '-' }}
              <div
                v-if="form.photos.url"
                class="upload-card">
                <img
                  :src="form.photos.url"
                  alt="" />
              </div>
            </span>
          </div>
        </section>
        <!-- Employee Benefits (E.B.) -->
        <section v-if="form.insurance_type >= 1200 && form.insurance_type < 1300">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Effective Date </span>
            <span>{{ form.eff_dt }}</span>
          </div>
          <div class="tr">
            <span>Business Nature </span>
            <span>
              {{ getGlobalOptionName('industry', form.business) }}
            </span>
          </div>
          <div class="tr">
            <span>No. of Employee(s)</span>
            <span>{{ form.no_of_employee }} Person</span>
          </div>
          <section v-show="form.insurance_type === 1202">
            <div class="tr">
              <span>Manual work involved?</span>
              <span>{{ getOptionName('yesNo2Options', form.manual_ind) | formatYesNo }}</span>
            </div>
            <div class="tr">
              <span>Stationed overseas?</span>
              <span>{{ getOptionName('yesNo2Options', form.oversea_ind) | formatYesNo }}</span>
            </div>
          </section>
          <section v-show="form.insurance_type !== 1203">
            <div class="tr">
              <span>Have you made or reported claim in the last 3 years?</span>
              <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
            </div>
          </section>
          <section v-show="form.insurance_type === 1203">
            <div class="tr">
              <span>No. of Spouse(s)</span>
              <span>{{ form.no_of_spouse }} Person</span>
            </div>
            <div class="tr">
              <span>No. of Kid(s)</span>
              <span>{{ form.no_of_kid }} Person</span>
            </div>
            <div class="tr">
              <span>No. of Member(s) Over Age 64</span>
              <span>{{ form.no_of_older }} Person</span>
            </div>
            <div class="tr">
              <span>Have you made or reported a claim in the last 3 years (At least for the past 9 months)?</span>
              <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
            </div>
          </section>
          <div class="tr">
            <span>Do you have any existing policy schedule(s)?</span>
            <span>{{ getOptionName('yesNo2Options', form.pcy_sch_ind) | formatYesNo }}</span>
          </div>
        </section>
        <!-- Public Liability -->
        <section v-if="form.insurance_type === 1301">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Effective Date </span>
            <span>{{ form.eff_dt }}</span>
          </div>
          <div class="tr">
            <span>Business Nature </span>
            <span>{{ getGlobalOptionName('industry', form.business) }}</span>
          </div>
          <div class="tr">
            <span>Limit of Liability</span>
            <span>{{ getGlobalOptionName('limit_of_liability', form.limit_of_liability) }}</span>
          </div>
          <div class="tr">
            <span>Have you made or reported claim in the last 3 years?</span>
            <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Do you have any existing policy schedule(s)?</span>
            <span>{{ getOptionName('yesNo2Options', form.pcy_sch_ind) | formatYesNo }}</span>
          </div>
          <span class="address-label">Insured Premises Address</span>
          <div class="tr">
            <span>Room</span>
            <span>{{ form.addr_room }}</span>
          </div>
          <div class="tr">
            <span>Floor</span>
            <span>{{ form.addr_floor }}</span>
          </div>
          <div class="tr">
            <span>Block</span>
            <span>{{ form.addr_block }}</span>
          </div>
          <div class="tr">
            <span>Building / Estate</span>
            <span>{{ form.addr_building }}</span>
          </div>
          <div class="tr">
            <span>Street</span>
            <span>{{ form.addr_street }}</span>
          </div>
          <div class="tr">
            <span>District</span>
            <span>{{ getAreaName('district', form.addr_district) }}</span>
          </div>
          <div class="tr">
            <span>Area</span>
            <span>{{ getAreaName('area', form.addr_area) }}</span>
          </div>
          <div class="tr">
            <span>Country / Region</span>
            <span>{{ getAreaName('region', form.addr_region) }}</span>
          </div>
        </section>
        <!-- Property -->
        <section v-if="form.insurance_type === 1401">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Effective Date </span>
            <span>{{ form.eff_dt }}</span>
          </div>
          <div class="tr">
            <span>Business Nature </span>
            <span>{{ getGlobalOptionName('industry', form.business) }}</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Building </span>
            <span>HK$ {{ form.sum_building | formatMoney }}</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Contents </span>
            <span>HK$ {{ form.sum_content | formatMoney }}</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Stock</span>
            <span>HK$ {{ form.sum_stock | formatMoney }}</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Machinery/Tools of Trade</span>
            <Span>HK$ {{ form.sum_mt | formatMoney }} </Span>
          </div>
          <div class="tr">
            <span>Have you made or reported claim in the last 3 years?</span>
            <div class="cloumn-box">
              <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
              <img
                :src="form.photos.url"
                alt="">
            </div>
          </div>
          <div class="tr">
            <span>Do you have any existing policy schedule(s)?</span>
            <span>{{ getOptionName('yesNo2Options', form.pcy_sch_ind) | formatYesNo }}</span>
          </div>
          <span class="address-label">Insured Premises Address</span>
          <div class="tr">
            <span>Room</span>
            <span>{{ form.addr_room }}</span>
          </div>
          <div class="tr">
            <span>Floor</span>
            <span>{{ form.addr_floor }}</span>
          </div>
          <div class="tr">
            <span>Block</span>
            <span>{{ form.addr_block }}</span>
          </div>
          <div class="tr">
            <span>Building / Estate</span>
            <span>{{ form.addr_building }}</span>
          </div>
          <div class="tr">
            <span>Street</span>
            <span>{{ form.addr_street }}</span>
          </div>
          <div class="tr">
            <span>District</span>
            <span>{{ getAreaName('district', form.addr_district) }}</span>
          </div>
          <div class="tr">
            <span>Area</span>
            <span>{{ getAreaName('area', form.addr_area) }}</span>
          </div>
          <div class="tr">
            <span>Country / Region</span>
            <span>{{ getAreaName('region', form.addr_region) }}</span>
          </div>
        </section>
        <!-- Marine Cargo -->
        <section v-if="form.insurance_type === 1701">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Interest / Goods to be insured</span>
            <span>{{ form.goods }}</span>
          </div>
          <div class="tr">
            <span>Packing</span>
            <span>{{ form.packing }}</span>
          </div>
          <div class="tr">
            <span>From</span>
            <span>{{ form.from }}</span>
          </div>
          <div class="tr">
            <span>To</span>
            <span>{{ form.to }}</span>
          </div>
          <div class="tr">
            <span>Via</span>
            <span>{{ form.via }}</span>
          </div>
          <!-- <div class="tr">
              <span>Voyage / Transit</span>
              <v-input v-model="formData.via" />
            </div> -->
          <div class="tr">
            <span>Conveyance</span>
            <span>{{ getGlobalOptionName('conveyance', form.conveyance) }}</span>
          </div>
          <div class="tr">
            <span>Currency</span>
            <span>{{ form.currency }}</span>
          </div>
          <div class="tr">
            <span>Basis of Valuation (Invoice Value)</span>
            <span>{{ form.valuation }}</span>
          </div>
          <div class="tr">
            <span>Terms of cover required</span>
            <span>{{ getGlobalOptionName('terms_of_cover_required', form.trm_of_cvr) }}</span>
          </div>
          <div class="tr">
            <span>Additional Conditions</span>
            <span>{{ form.additional_conditions}}</span>
          </div>
        </section>
        <!-- Other -->
        <section v-if="form.insurance_type === 9000">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Insurance Type</span>
            <span>
              <span
                v-for="(item, index) in form.other_insurance_type"
                :key="index"
                class="block">
                {{ getOptionName('ticketOptions.insuranceTypeOptions', item) }}
              </span>
            </span>
            <!-- <v-checkbox-group
              v-model="formData.other_insurance_type"
              :block="true"
              :list="ticketOptions.insuranceTypeOptions" /> -->
          </div>
          <div class="tr">
            <span>Message</span>
            <span>{{ form.message }}</span>
          </div>
        </section>
        <!-- Motors Fleet / Motor Trade -->
        <section v-if="form.insurance_type >= 1500 && form.insurance_type < 1600">
          <section v-if="form.insurance_type === 1501">
            <div class="tr">
              <span>Type of insured</span>
              <span>Motors Fleet</span>
            </div>
            <div class="tr">
              <span>Name of insured</span>
              <span>{{ form.isrd_nm }}</span>
            </div>
            <div class="tr">
              <span>Business Nature </span>
              <span>{{ getGlobalOptionName('industry', form.isrd_bo) }}</span>
            </div>
            <div class="tr">
              <span>Vehicle Type</span>
              <span>{{ getGlobalOptionName('vehicle_type', form.vehicle_type) }}</span>
            </div>
          </section>

          <section v-if="form.insurance_type === 1502">
            <div class="tr">
              <span>Type of insured</span>
              <span>Motor Trade</span>
            </div>
            <div class="tr">
              <span>Number of driver(s)</span>
              <span>{{ form.no_of_nm_drvr }}</span>
              <!-- <v-radio-group
                v-model="formData.no_of_nm_drvr"
                :border="true"
                :list="numberFourOptions" /> -->
            </div>
            <div class="tr">
              <span>Business / Occupation</span>
              <span>{{ getGlobalOptionName('industry', form.isrd_bo) }}</span>
            </div>
          </section>
        </section>
      </div>
      <section v-if="form.insurance_type === 1502">
        <h2>Insured Driver(s)</h2>
        <drivers-info-motor :form="form.nm_drvr_list" />
      </section>

    </template>
    <template v-else-if="type === 3">
      <h2>Request Detail</h2>
      <div class="table strip">
        <div class="tr th">
          <span >Item</span>
          <span class="bold">Information</span>
        </div>
        <!-- <div class="tr">
          <span>Effective Date</span>
          <span></span>
        </div> -->
        <div class="tr">
          <span>Contact Number</span>
          <span>{{ form.contact_no }}</span>
        </div>
        <!--        <div class="tr">-->
        <!--          <span>Preferred Time for Call-back</span>-->
        <!--          <span>{{ getGlobalOptionName('call_back_preferred_time', form.preferred_time) }}</span>-->
        <!--        </div>-->
        <!-- <div class="tr">
          <span>Action</span>
          <span>{{ form.action_language }}</span>
        </div> -->
      </div>
      <h2>Endorsement Type</h2>
      <div class="table strip">
        <div class="tr th">
          <span>Endorsement Type</span>
          <span class="bold">Information</span>
        </div>
        <div class="tr">
          <span>Action</span>
          <span>{{ form.action_language }}</span>
        </div>
        <div class="tr">
          <span>Type</span>
          <span v-if="charge_language.length>0">
            <p
              v-for="(item,index) in charge_language"
              :key="index">{{item.name}}</p>
          </span>
        </div>
      </div>
      <!-- <template v-if="form.action === 1">
        <h2>Endorsement Type</h2>
        <div class="table strip">
          <div class="tr th">
            <span>Endorsement Type</span>
            <span>Information</span>
          </div>
          <div class="tr">
            <span>Insurance History And Claim Record</span>
            <span>{{ getOptionName('yesNo2Options', form.insurance_claim_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Change Policyholder Information</span>
            <span>{{ getOptionName('yesNo2Options', form.change_policy_holder_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Change Driver Information</span>
            <span>{{ getOptionName('yesNo2Options', form.change_driver_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Change Car Detail</span>
            <span>{{ getOptionName('yesNo2Options', form.change_car_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Other</span>
            <span>{{ getOptionName('yesNo2Options', form.other_ind) | formatYesNo }}</span>
          </div>
        </div>
      </template> -->
      <h2>Message</h2>
      <p
        v-if="form.message"
        v-html="changeLineData(form.message)"></p>
      <span v-else>No Message</span>
      <!-- 文件 -->
      <file-container
        v-for="(item, index) in form.other_file"
        :key="index"
        :fileData="item" />
    </template>
    <template v-else-if="type === 4">
      <h2>Request Detail</h2>
      <div class="table">
        <div class="tr">
          <span>Type</span>
          <span>{{form.action_language}}</span>
        </div>
      </div>
      <div class="table strip">
        <div class="tr">
          <span>Transfer Type</span>
          <span>{{ getOptionName('cashout_list',form.type) }}</span>
        </div>
        <div class="tr">
          <span>Transfer Amount</span>
          <span>{{ form.money }} ( {{ `$${form.money/100}`}} )</span>
        </div>
        <div class="tr">
          <span>Cardholder Name</span>
          <span>{{ form.card_holder }}</span>
        </div>
        <div class="tr">
          <span>Issuing Bank</span>
          <span>{{form.bank_code}} - {{ form.card_bank }}</span>
        </div>
        <div class="tr">
          <span>Credit Card Number</span>
          <span>{{ form.card_number }}</span>
        </div>
      </div>
    </template>
    <template v-else-if="type === 7">
      <h2>Request Detail</h2>
      <div class="table strip">
        <div class="tr th">
          <span>Item</span>
          <span class="bold">Information</span>
        </div>
        <div class="tr">
          <span>Client Name</span>
          <span>{{ form.name }}</span>
        </div>
        <div class="tr">
          <span>Client Contact Number</span>
          <span
            :class="{
              'blue': form.is_registered
            }">
            {{ form.phone }}
            <span
              v-if="form.is_registered"
              class="span-status status-blue">Registered</span>
            <span
              v-else
              class="span-status">Not Registered</span>
          </span>
        </div>
        <!-- <div class="tr">
          <span>Contact Number</span>
          <span>test</span>
        </div> -->
        <div class="tr">
          <span>Product Type</span>
          <span>{{ form.product_language }}</span>
        </div>
        <div class="tr">
          <span>Your Nickname </span>
          <span>{{ form.nick_name }}</span>
        </div>
        <div class="tr">
          <span>Remark</span>
          <span>{{ form.remark }}</span>
        </div>
        <!-- <div class="tr">
          <span>Supporting Doc. </span>
          <span class="blue pointer">paper.pdf</span>
        </div> -->
        <div
          v-for="(item, index) in form.other_file"
          :key="index"
          class="tr">
          <span>Supporting Doc. </span>
          <span
            class="blue pointer"
            @click="openFile(item.url)">{{ item.client_name }}</span>
        </div>
      </div>

    </template>
    <!-- Claim -->
    <template v-else-if="type==6">
      <claim-info
        :form="form"
        :record="record"
        @editClaim="handleEitClaim"></claim-info>
    </template>
    <!-- <template v-else-if="type === 6">
      <div class="table strip">
        <div class="tr th">
          <span>Item</span>
          <span>Information</span>
        </div>
        <div class="tr">
          <span>Accident Date</span>
          <span>{{ form.accident_date }}</span>
        </div>
        <div class="tr">
          <span>Contact Person</span>
          <span>{{ form.contact_person }}</span>
        </div>
        <div class="tr">
          <span>Contact Number</span>
          <span>{{ form.contact_no }}</span>
        </div>
        <div class="tr">
          <span>Brief Description Of The Accident</span>
          <span>{{ form.description }}</span>
        </div>
        <div class="tr">
          <span>Claim Form</span>
          <span
            class="blue pointer"
            @click="openFile(form.claim_form.url)">{{form.claim_form? 'claimform.pdf': '-' }}</span>
        </div>
        <div
          v-for="(item) in form.other_file"
          :key="item.id"
          class="tr">
          <span>Documents</span>
          <span
            class="blue pointer"
            @click="openFile(item.url)">{{ item.client_name }}</span>
        </div>
        <div
          v-if="!form.other_file"
          class="tr">
          <span>Documents</span>
          <span>-</span>
        </div>
      </div>
    </template> -->
    <template v-else>
      <h2>Request Detail</h2>
      <div class="table strip">
        <div class="tr th">
          <span>Item</span>
          <span class="bold">Information</span>
        </div>
        <div class="tr">
          <span>Accident Date</span>
          <span>{{ form.accident_date }}</span>
        </div>
        <div class="tr">
          <span>Contact Person</span>
          <span>{{ form.contact_person }}</span>
        </div>
        <div class="tr">
          <span>Contact Number</span>
          <span>{{ form.contact_no }}</span>
        </div>
        <div class="tr">
          <span>Brief Description Of The Accident</span>
          <span
            class="pre_wrap"
            :class="{'hand blue':policyInfo.flight_delay_id}"
            @click="handleFlight">{{ form.description }}</span>
        </div>
        <!-- <div class="tr">
          <span>Claim Form</span>
          <span>{{form.claim_form? 'claimform.pdf': '-' }}</span>
        </div> -->
        <div
          v-for="(item, index) in form.other_file"
          :key="index"
          class="tr">
          <span>Documents</span>
          <span
            class="blue pointer"
            @click="openFile(item.url)">{{ item.client_name }}</span>
        </div>
        <div
          v-if="!form.other_file"
          class="tr">
          <span>Documents</span>
          <span>-</span>
        </div>
      </div>
    </template>
  </section>
</template>
<script>
// import BaseInfo from '@/views/components/base-info'
import DriversInfo from './info/drivers-info'
import DriversInfoMotor from './drivers-info-motor'
import MixinOptions from '@/mixins/options'
import InsuredVehicleInfo from '@/views/components/insured-vehicle-info'
import PolicyHolderInfo from './info/policy-holder-info'
import MixinFormat from '@/mixins/format'
import FileContainer from '@/views/components/file-container'
import HousemaidQuoteInfo from '@/views/components/modules/housemaid/housemaid-quote-info'
import DecorationQuoteInfo from '@/views/components/modules/decoration/decoration-quote-info'
import HomefireQuoteInfo from '@/views/components/modules/homefire/homefire-quote-info'
import travelQuoteInfo from '@/views/components/modules/travel/travel-quote-info'
import fireQuoteInfo from '@/views/components/modules/homefire/fire-quote-info'
import IndustryInfo from '@/views/tickets/components/info/industry-info'
import quickQuoteInfo from '@/views/components/quick-quote-info'
import StudentQuoteInfo from '@/views/components/modules/student/student-quote-info'
import WorkingQuoteInfo from '@/views/components/modules/working/working-quote-info'
import PersonalQuoteInfo from '@/views/components/modules/personal/personal-quote-info'
import DroneQuoteInfo from '@/views/components/modules/drone/drone-quote-info'
import petQuoteInfo from '@/views/components/modules/pet/pet-quote-info'
import smeKycInfo from '@/views/quoting/sme/component/smeKycInfo'
import smeQucikInfo from '@/views/quoting/sme/component/smeQucikInfo'
import {mapState} from 'vuex'
import claimInfo from '../components/claim/info'
export default {
  name: 'RequestDetail',
  components: {
    WorkingQuoteInfo,
    StudentQuoteInfo,
    // BaseInfo,
    DriversInfo,
    DriversInfoMotor,
    InsuredVehicleInfo,
    PolicyHolderInfo,
    FileContainer,
    HousemaidQuoteInfo,
    DecorationQuoteInfo,
    HomefireQuoteInfo,
    fireQuoteInfo,
    IndustryInfo,
    quickQuoteInfo,
    travelQuoteInfo,
    PersonalQuoteInfo,
    smeKycInfo,
    smeQucikInfo,
    DroneQuoteInfo,
    petQuoteInfo,
    claimInfo
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    type: {
      type: Number,
      default: 2 // 1-General 2-refer case 3-endorsement 4-credit transfer 5-business 6-Claims 7-Referral Request
    },
    form: {
      type: Object,
      default: () => ({})
    },
    policyInfo: {
      type: Object,
      default: () => ({})
    },
    record:{
      type: Array,
      default: () => ([])
    },
    customer: {
      type: [Object,Array],
      default: () => ({})
    },
    disabledEdit: {
      type: Boolean,
      default: false
    },
    isAttachCustomer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('ticket', ['referData']),
    isHzmb(){
      let {class_id} = this.form||{}
      return class_id==15
    },
    charge_language(){
      let {charge_language=[]} = this.form||{}
      return charge_language||[]
    },
    referrer(){
      let {referral_info={}} = this.form||{}
      return referral_info||{}
    },
    relation(){
      let {relation={}} = this.form||{}
      return relation||{}
    },
    isIndustry() {
      return [
        2001, 2101, 2201, 2301, 2401, 2501, 2601, 2701
      ].includes(this.form.insurance_type)
    },
    productId() {
      return this.form.product_id
    },
    classId() {
      return this.form.class_id || 14
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    mortgagorOption() {
      // 拿status 為1的數據
      let { mortgagor=[] } = this.localAllOptions
      if(mortgagor.length) {
        mortgagor = mortgagor.filter(e=>e.status)
      }
      return mortgagor
    },
    isMortgagorOther(){
      let {mortgagor}=this.form
      let list = this.mortgagorOption.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    benefits() {
      if(!this.localAllOptions || !this.localAllOptions.benefits || !this.form.benefits) {
        return []
      }
      return this.localAllOptions.benefits.filter(item => {
        return this.form.benefits.includes(item.id)
      })
    },
    extraBenefitSelect(){
      let {extra_benefits_content={}} = this.form
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr||[]
    },
    insuranceType() {
      const { insurance_type } = this.form
      let type = insurance_type
      if(type > 1500 && type <= 1599) {
        type = 1500
      }
      if(type > 1200 && type < 1299) {
        type = 1200
      }
      const { allTypeOptions } = this.ticketOptions
      const list = [
        ...allTypeOptions,
        ...this.industryTypeOptions
      ]


      return this.getOptionName('', type, list)
    },
    isMotorTrade(){
      return this.classId ==13
    },
    isTPlate(){
      let {type_of_ins} = this.form||{}
      return type_of_ins ==1
    }
    // claimOtherFile() {
    //   let result = []
    //   for(let i = 1; i <= 6; i++) {
    //     if(this.form[`other_file_${i}`]) {
    //       result.push(this.form[`other_file_${i}`])
    //     }
    //   }
    //   return result
    // }
  },
  mounted() {
  },
  methods: {
    handleEitClaim(index){
      this.$emit('editClaim',index)
    },
    handleFlight(){
      let {flight_delay_id} = this.policyInfo||{}
      if(flight_delay_id){
        this.$router.push(`/records/micropolicy/flight-delay/${flight_delay_id}`)
      }
    },
    openFile(url) {
      if(!url) {
        return
      }
      window.open(url, '_blank')
    },
    getLocalAllOptionName(target, value) {
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/.sme-container__info{
  margin-bottom: 30px;
  .box{
    width: 100%;
    max-width: 100%;
  }
}
.request-detail {
    .pt-20{
      padding-top: 20px;
    }
    .pre_wrap{
      white-space: pre-wrap;
    }
    .blue{
      color: #0366D6 !important;
    }
    position: relative;
    .table{
      .th{
        padding: 16px;
        background: $gray;
        border: 1px solid #E1E4E8;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        color: $dark!important;
        font-weight: 600;
      }
      .tr {
        padding: 8px 16px;
        border: 1px solid #D1D5DA;
        background: #fff!important;
        display: flex;
        min-height: 36px;
        &--none_border_top{
          border-top: 0px;
        }
        span{
          &:first-child{
            color: #586069;
            font-weight: 600;
            font-size: 14px;
          }
          &:last-child{
            color: #24292E;
            font-weight: 400;
            font-size: 14px;
          }
        }
        & + .tr{
          border-top: 0;
        }
        &:first-child{
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        &:last-child{
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        &.tr_none--border{
          border: 0;
          border-bottom: 1px solid #dddfe7;
          padding: 5px;
          &:first-child{
            border-top-left-radius:0px!important;
            border-top-right-radius:0px!important;
          }
          &:last-child{
            border-bottom-left-radius: 0px!important;
            border-bottom-right-radius: 0px!important;
          }
        }
      }

    }
    .address-label {
      display: block;
      padding-top: 24px;
      padding-bottom: 16px;
      font-size: 16px;
      color: #616266;
      font-weight: 400;
    }
    p {
      padding-bottom: 10px;
    }
    .span-status {
      display: inline-block;
      margin-left: 5px;
      padding: 3px 10px;
      background: #dbab09;
      border-radius: 12px;
      font-size: 12px;
      line-height: 14px;
      color: #fff;
      &.status-blue {
        background: #0366D6;
      }
      &.blue{
        background: #fff;
        border: 1px solid #0366D6;
      }
    }
    .file-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        padding: 0 15px;
        height: 65px;
        border: 1px solid #dddfe7;
        border-radius: 4px;
        background: #fcfcfc;
        .file-info {
          color: #616266;
          font-size: 16px;
        }
      }
  .bold{
    font-weight: bold;
  }
  .cloumn-box{
    display: flex;
    flex-direction: column;
    flex: 1;
    img{
      display: block;
      width: 50%;
    }
  }
  .upload-card {
    margin-top: 10px;
    z-index: 0;
    position: relative;
    display: flex;
    //justify-content: center;
    align-items: center;
    width: 250px;
    height: 150px;
    //border: 1px dashed #91939A;
    border-radius: 4px;
    background: $blue;
    img {
      max-width: 100%;
      max-height: 100%;
      z-index: 3;
    }
  }
}
.asap{
  font-weight: bold;
  color: black;
  margin-left: 5px;
}
</style>
